import React from "react";
import { FaHackerrank } from "react-icons/fa";
import { SiLeetcode, SiGeeksforgeeks } from "react-icons/si";
import { Container, Row, Col } from "react-bootstrap";
import Zoom from "react-reveal/Zoom";

// Array of ranking platforms
const rankingPlatforms = [
  {
    name: "LeetCode",
    link: "https://leetcode.com/u/prashantmalviya272002/",
    icon: <SiLeetcode />,
  },

  {
    name: "GeeksforGeeks",
    link: "https://www.geeksforgeeks.org/user/prashant_malviya2002/",
    icon: <SiGeeksforgeeks />,
  },

  {
    name: "HackerRank",
    link: "https://www.hackerrank.com/profile/prashantmalviya2",
    icon: <FaHackerrank />,
  },
];

export default function Ranking() {
  return (
    <div className="mt-4">
      <Zoom left cascade>
        <h1>See my rank</h1>
      </Zoom>
      <Container className="mt-5">
        <Row className="g-5 justify-center">
          {rankingPlatforms.map((platform, index) => (
            <Col md={3} key={index}>
              <a
                href={platform.link}
                target="_blank"
                rel="noreferrer"
                className="icon-colour home-social-icons"
              >
                <div className="flex justify-center items-center mt-4">
                  <Zoom cascade>{platform.icon}</Zoom>
                </div>
              </a>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
